
export default function CheckEnclosed() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='check-enclosed'>
        <path
          id='Vector'
          d='M10.361 18.3845C14.9201 18.3845 18.6979 14.614 18.6979 10.0548C18.6979 5.49561 14.9129 1.7251 10.3537 1.7251C5.7985 1.7251 2.03125 5.49561 2.03125 10.0548C2.03125 14.614 5.80576 18.3845 10.361 18.3845ZM10.361 17.1577C6.42966 17.1577 3.26927 13.9934 3.26927 10.0548C3.26927 6.11624 6.4224 2.95186 10.3537 2.95186C14.2923 2.95186 17.4639 6.11624 17.4639 10.0548C17.4639 13.9934 14.2995 17.1577 10.361 17.1577ZM9.46639 13.9666C9.70288 13.9666 9.90058 13.852 10.0508 13.6326L13.9354 7.53713C14.0185 7.39674 14.1049 7.23207 14.1049 7.07391C14.1049 6.75433 13.8216 6.54033 13.5133 6.54033C13.3268 6.54033 13.1444 6.65096 13.0047 6.86643L9.43411 12.5596L7.66999 10.3332C7.49406 10.1032 7.33265 10.0426 7.13243 10.0426C6.82011 10.0426 6.56984 10.2936 6.56984 10.6197C6.56984 10.7771 6.63766 10.9345 6.73776 11.0742L8.84574 13.6326C9.0322 13.8698 9.21937 13.9666 9.46639 13.9666Z'
          fill='#1F2647'
        />
      </g>
    </svg>
  );
}
